import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M3.92,17.38A1,1,0,0,0,5,16.84H5a1,1,0,0,0-.75-1.47,2.57,2.57,0,0,1-1.59-.71A2.38,2.38,0,0,1,2,12.87a2.58,2.58,0,0,1,1-2,2.61,2.61,0,0,1,1.64-.58,3.27,3.27,0,0,1,.53.05,1,1,0,0,0,.81-.18,1,1,0,0,0,.39-.78,4.52,4.52,0,0,1,1-3c3.35-3.8,8.22-2.47,9.85,1a1,1,0,0,0,1,.57,3.7,3.7,0,0,1,2.72,1A3.75,3.75,0,0,1,22,11.68a3.89,3.89,0,0,1-2.48,3.61,1,1,0,0,0-.59,1.37h0a1,1,0,0,0,1.16.47A5.6,5.6,0,0,0,24,11.93a5.85,5.85,0,0,0-1-3.54,5.77,5.77,0,0,0-4.2-2.46.28.28,0,0,1-.19-.12A7.69,7.69,0,0,0,4.49,8.1a.24.24,0,0,1-.22.2A4.63,4.63,0,0,0,.62,10.55,4.42,4.42,0,0,0,0,13a4.28,4.28,0,0,0,1.24,3.09A5,5,0,0,0,3.92,17.38Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M13.28,10.2a1.45,1.45,0,0,0-2.56,0L5.66,19.83a1.44,1.44,0,0,0,1.28,2.1H17.06a1.44,1.44,0,0,0,1.28-2.1ZM12,20.18a1,1,0,1,1,1-1A1,1,0,0,1,12,20.18Zm-.75-6.75a.75.75,0,0,1,1.5,0v3a.75.75,0,0,1-1.5,0Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }